document.addEventListener('DOMContentLoaded', () => {
  /* Delegate to document so cards added by the theme editor are handled */
  document.addEventListener('click', (event) => {
    /* Let clicks inside the video area pass through without toggling */
    if (event.target.closest('.cotton-identify__media')) return;

    const card = event.target.closest('.cotton-identify__card');
    if (!card) return;

    const toggle = card.querySelector('.cotton-identify__toggle');
    if (!toggle) return;

    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    card.classList.toggle('is-open', !isOpen);
  });
});
